import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { accountNumber, password, username, userPassMap } from '../internal.js'

const credentialTypes = [username, password] as const
const locationCredentialTypes = [accountNumber] as const

export type seflCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const seflDocumentTypes = [
  'letter-of-authority',
  'lumper-certificate',
  'packing-slip',
  'proof-of-delivery',
  'reconsignment-authorization',
  'signed-bol',
  'weight-and-research-inspection',
] as const satisfies readonly DocumentType[]

export const sefl: CarrierDef<seflCredType> = {
  name: 'Southeastern Freight Lines',
  scac: 'sefl',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed by 5pm',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Guaranteed by Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
    { id: 'volume', name: 'Volume' },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [...userPassMap, ['account-number', 'ref1']],
  engineLayers: [
    'rating',
    'bol',
    'pickup',
    'profinder',
    'documents',
    'tracking',
  ],
  documentTypes: seflDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
